import { PlannedDebtLimitIncreaseType } from '@g2-shared/api-client/generated/risk-app';

export const DebtLimitIncreaseStrategyTypeOptions: Record<PlannedDebtLimitIncreaseType, string> = {
  [PlannedDebtLimitIncreaseType.EVERYDAY]: 'EveryDay',
  [PlannedDebtLimitIncreaseType.MONTHLY]: 'Monthly',
  [PlannedDebtLimitIncreaseType.PERIODIC]: 'Periodic',
  [PlannedDebtLimitIncreaseType.WEEKLY]: 'Weekly',
};
